import { HotModuleReplacementPlugin } from 'webpack';

export default config => (
  new HotModuleReplacementPlugin(config)
);
